import React from "react";
import Registerslider from "../registerslider";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import localimgpath from "../../js/localimgpath";
import EventBgColorsData from "../../js/eventBgColorsData";
import Functions from "./index.functon";
const AuthSlide = () => {
  const { talentImageList, settings } = Functions();
  return (
    <div className="lg:py-3 xs:py-2 sm:py-3">
      <Slider {...settings}>
        {talentImageList?.map((slide, index) => (
          <div key={index}>
            <Registerslider
              image={`${localimgpath.talentThumbnail}/${slide}`}
              bgColor={
                EventBgColorsData[index % EventBgColorsData.length].eventtheme
              }
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default AuthSlide;
